import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import ContactUsForm from "components/forms/TwoColContactUsWithIllustrationFullForm.js";
import ContactDetails from "components/cards/ThreeColContactDetails.js";

const Address = tw.span`leading-relaxed`;
const AddressLine = tw.span`block`;
const Email = tw.span`text-sm mt-6 block text-gray-500`;
const Phone = tw.span`text-sm mt-0 block text-gray-500`;

export default () => {
  return (
    <AnimationRevealPage>
      <Header />
      <ContactUsForm />
      <ContactDetails
        cards={[
          {
            title: "Warszawa",
            description: (
              <>
                <Address>
                  <AddressLine>ul. Elektoralna 11</AddressLine>
                  <AddressLine>00-137 Warszawa</AddressLine>
                </Address>
                <Email>kontakt@e-cenowki.pl</Email>
                <Phone>+48 606 485 873</Phone>
              </>
            )
          },
          {
            title: "Kraków",
            description: (
              <>
                <Address>
                  <AddressLine>ul. Winnicka 59R</AddressLine>
                  <AddressLine>30-394 Kraków</AddressLine>
                </Address>
                <Email>kontakt@e-cenowki.pl</Email>
                <Phone>+48 693 756 613</Phone>
              </>
            )
          },
          {
            title: "",
            description: (
              <>
                <Address>
                  <AddressLine></AddressLine>
                  <AddressLine></AddressLine>
                </Address>
                <Email></Email>
                <Phone></Phone>
              </>
            )
          },
          {
            title: "",
            description: (
              <>
                <Address>
                  <AddressLine></AddressLine>
                  <AddressLine></AddressLine>
                </Address>
                <Email></Email>
                <Phone></Phone>
              </>
            )
          },
          {
            title: "",
            description: (
              <>
                <Address>
                  <AddressLine></AddressLine>
                  <AddressLine></AddressLine>
                </Address>
                <Email></Email>
                <Phone></Phone>
              </>
            )
          },
          {
            title: "",
            description: (
              <>
                <Address>
                  <AddressLine></AddressLine>
                  <AddressLine></AddressLine>
                </Address>
                <Email></Email>
                <Phone></Phone>
              </>
            )
          }
        ]}
      />
      <Footer />
    </AnimationRevealPage>
  );
};
